import SpriteSymbol from "../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\"><path d=\"M435.661 718.19S679.14 248.84 959.237 64.133c-34.504 88.516-21.999 254.23 0 342.578-136.586 31.18-417.4 381.577-508.456 552.864C321.842 796.018 171.22 690.355 63.79 632.546l147.7-141.183L435.66 718.19z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol